'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _Textarea = require('./Textarea.style');

var _FieldWrapper = require('../FieldWrapper/FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Basic form textarea input. All other props passed to this component will be
 * passed through to the actual textarea element.
 */
var Textarea = function Textarea(_ref) {
  var className = _ref.className,
      description = _ref.description,
      error = _ref.error,
      focused = _ref.focused,
      label = _ref.label,
      name = _ref.name,
      rows = _ref.rows,
      wrapperProps = _ref.wrapperProps,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['className', 'description', 'error', 'focused', 'label', 'name', 'rows', 'wrapperProps']);
  return _react2.default.createElement(
    _FieldWrapper2.default,
    (0, _extends3.default)({
      description: description,
      error: error,
      label: label,
      labelFor: name
    }, wrapperProps),
    _react2.default.createElement(
      'div',
      { className: 'textarea ' + className },
      _react2.default.createElement('textarea', (0, _extends3.default)({}, rest, {
        id: name,
        name: name,
        rows: rows
      }))
    )
  );
};

exports.Textarea = Textarea;
Textarea.propTypes = {
  /**
   * className for glamorous styles
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Helper description for tooltip
   */
  description: _propTypes2.default.string,
  /**
   * Error message for textarea. Alters textarea style and displays error message if set.
   */
  error: _propTypes2.default.string,
  /**
   * Whether this component has focus or not.
   * Automatically set by onFocus and onBlur coming
   * from withFocus HOC
   */
  focused: _propTypes2.default.bool,
  /**
   * Field label text to display above textarea
   */
  label: _propTypes2.default.string,
  /**
   * Field name in form
   */
  name: _propTypes2.default.string,
  /**
   * Function to call on textarea blur
   */
  onBlur: _propTypes2.default.func,
  /**
   * Function to call on textarea change
   */
  onChange: _propTypes2.default.func,
  /**
   * Function to call on textarea focus
   */
  onFocus: _propTypes2.default.func,
  /**
   * Placeholder text for textarea
   */
  placeholder: _propTypes2.default.string,
  /**
   * Number of rows for this Textarea
   */
  rows: _propTypes2.default.number,
  /**
   * Input value
   */
  wrapperProps: _propTypes2.default.object,
  /**
   * props defined in the instrument for the purpose of style
   */
  value: _propTypes2.default.string
};
Textarea.defaultProps = {
  rows: 5
};

exports.default = (0, _helpers.withFocus)((0, _glamorous2.default)(Textarea)(_Textarea.defaultStyle, _Textarea.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Textarea/Textarea.js
// module id = 612
// module chunks = 0